import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-shimmer rounded-md",
        "bg-[linear-gradient(90deg,var(--skeleton-base)_25%,var(--skeleton-highlight)_50%,var(--skeleton-base)_75%)]",
        "bg-[length:200%_100%]",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
